export default "__VITE_ASSET__rq73a68D__"